<form>
    <div class="title-outer">
        <h2 class="form-title">{{ languageService.languageJSON.ReleaseOverview_Title }}</h2>
    </div>

    <div class="form-section table">
        <div class="flex-outer flex-column table">
            <div class="flex-row header table-header">
                <div class="flex-col medium-col">
                    {{ languageService.languageJSON.ConfigurationDetails_BikeComponents }}
                </div>
                <div class="flex-col medium-col">
                    {{ languageService.languageJSON.ReleaseOverview_AffectedConfigurations }}
                </div>
                <div class="flex-col">
                    {{ languageService.languageJSON.ComponentDetails_OEMName }}
                </div>
            </div>
            <div class="flex-row" *ngIf="dataError">
                <div class="flox-col error">{{ languageService.languageJSON.Global_ServerError_Title}}</div>
            </div>

            <!-- COMPONENT CLASS -->
            <div class="flex-row component-class-row"
                *ngFor="let releaseComponentClass of releaseList; let index = index;" [hidden]="loading">
                <div class="flex-col">
                    <div class="flex-dropdown-trigger-outer">
                        <div class="flex-dropdown-trigger"
                            (click)="onDropdownClick('cc' + releaseComponentClass.componentClass.id)">
                            <div class="trigger-icon"
                                [ngClass]="{'opened': getDropdown('cc' + releaseComponentClass.componentClass.id)}">
                                <img class="arrow-icon" src="assets/icons/angle-bottom-icon.svg" />
                            </div>
                            <img class="component-icon" src="assets/icons/file-manager-icon.svg" />
                            <b>{{ releaseComponentClass.componentClass.name }}</b>
                        </div>
                    </div>

                    <!-- COMPONENT -->
                    <div class="flex-sub-row" *ngFor="let releaseComponent of releaseComponentClass.components"
                        [hidden]="!getDropdown('cc' + releaseComponentClass.componentClass.id)">
                        <div class="flex-sub-col">
                            <div class="flex-row">
                                <div class="flex-col medium-col">
                                    <div class="flex-dropdown-trigger"
                                        (click)="onDropdownClick('c' + releaseComponent.component.id)">
                                        <div class="trigger-icon"
                                            [ngClass]="{'opened': getDropdown('c' + releaseComponent.component.id)}">
                                            <img class="arrow-icon" src="assets/icons/angle-bottom-icon.svg" />
                                        </div>
                                        <img class="component-icon" src="assets/icons/setting-icon.svg" />
                                        <span>{{ releaseComponent.component.name}}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- COMPONENT VARIANT -->
                            <div class="flex-sub-row"
                                *ngFor="let componentVariant of releaseComponent.componentVariants"
                                [hidden]="!getDropdown('c' + releaseComponent.component.id)">
                                <div class="flex-sub-col">
                                    <div class="flex-row">
                                        <div class="flex-col medium-col">
                                            <div class="flex-dropdown-trigger"
                                                (click)="onDropdownClick('cv' + componentVariant.variant.id)">
                                                <div class="trigger-icon"
                                                    [ngClass]="{'opened': getDropdown('cv' + componentVariant.variant.id)}">
                                                    <img class="arrow-icon" src="assets/icons/angle-bottom-icon.svg" />
                                                </div>
                                                <img class="component-icon" src="assets/icons/setting-icon.svg" />
                                                <span>{{ componentVariant.variant.name}}</span>
                                            </div>
                                        </div>

                                        <div class="flex-col medium-col" *ngIf="index==0">
                                            <a (click)="viewAllConfiguration()">{{
                                                languageService.languageJSON.Global_All
                                                }}</a>
                                        </div>
                                        <div class="flex-col medium-col" *ngIf="index>0">
                                            <span
                                                *ngFor="let configuration of componentVariant.configurations; last as last">
                                                <a (click)="viewConfiguration(configuration)">C{{configuration}}</a>
                                                <span class="config-divider" *ngIf="!last">, </span>
                                            </span>
                                        </div>
                                        <div class="flex-col">
                                            {{ componentVariant.variant.OEMName }}
                                        </div>
                                    </div>

                                    <!-- RELEASES -->
                                    <div class="flex-table" [hidden]="!getDropdown('cv' + componentVariant.variant.id)">
                                        <div class="flex-row header">
                                            <div class="flex-col large-col">
                                                {{ languageService.languageJSON.ManageBikes_Filename }}
                                            </div>
                                            <div class="flex-col">
                                                {{ languageService.languageJSON.ConfigurationDetails_Version }}
                                            </div>
                                            <div class="flex-col">
                                                {{ languageService.languageJSON.ReleaseDetails_ActivationStatus }}
                                            </div>
                                            <div class="flex-col">
                                                {{ languageService.languageJSON.ReleaseDetails_ApprovalStatus }}
                                            </div>
                                            <div class="flex-col">
                                                {{ languageService.languageJSON.ReleaseDetails_RolloutStatus }}
                                            </div>
                                            <div class="flex-col medium-col"></div>
                                            <div class="flex-col modify-icons"></div>
                                        </div>
                                        <div class="flex-row" *ngFor="let releaseElement of componentVariant.releases">
                                            <div class="flex-col large-col">
                                                {{ releaseElement.FileName }}
                                            </div>
                                            <div class="flex-col">
                                                {{ releaseElement.ReleaseVersion }}
                                            </div>
                                            <div class="flex-col color-grey" [ngClass]="{'color-red':releaseElement.ActivationStatus==1,
                                            'color-green': releaseElement.ActivationStatus==2}">
                                                {{ getActivationStatus(releaseElement.ActivationStatus) }}
                                            </div>
                                            <div class="flex-col color-grey"
                                                [ngClass]="{'color-red':releaseElement.ApprovalStatus==1,
                                            'color-green': releaseElement.ApprovalStatus==2 || releaseElement.ApprovalStatus==3}">
                                                {{ getApprovalStatus(releaseElement.ApprovalStatus) }}
                                            </div>
                                            <div class="flex-col color-grey" [ngClass]="{'color-red':releaseElement.RolloutStatus==3,
                                            'color-green': releaseElement.RolloutStatus==2}">
                                                {{ getRolloutStatus(releaseElement.RolloutStatus) }}
                                                <span *ngIf="releaseElement.RolloutUsedBy">({{
                                                    releaseElement.RolloutUsedBy
                                                    }})</span>
                                            </div>
                                            <div class="flex-col modify-icons medium-col"
                                                *ngIf="releaseElement.ModifyRole">
                                                <button
                                                    *ngIf="releaseElement.ApprovalStatus==3 && releaseElement.ActivationStatus==1"
                                                    [ngClass]="{'inactive-with-popup': releaseElement.InactiveButton}"
                                                    [matTooltip]="releaseElement.InactiveButton ? languageService.languageJSON.ReleaseOverview_DowngradeProtection: ''"
                                                    matTooltipClass="configtool-tooltip"
                                                    [matMenuTriggerFor]="!releaseElement.InactiveButton ? menu: null">{{
                                                    languageService.languageJSON.Global_Activate }}</button>

                                                <mat-menu #menu="matMenu">
                                                    <button *ngFor="let option of rolloutUsedByOptions" mat-menu-item
                                                        (click)="startRollout(releaseElement, option.id)">
                                                        {{ option.startValue }}</button>
                                                </mat-menu>

                                                <button
                                                    *ngIf="(releaseElement.ApprovalStatus==1 || releaseElement.ApprovalStatus==3) && releaseElement.ActivationStatus==1"
                                                    (click)="openStartApproval(releaseElement.Id)">{{
                                                    languageService.languageJSON.ReleaseOverview_StartApproval}}</button>
                                                <button
                                                    *ngIf="releaseElement.ApprovalStatus==1 && releaseElement.ActivationStatus==1"
                                                    (click)="forceApproval(releaseElement)">{{
                                                    languageService.languageJSON.ReleaseOverview_ForceApproval
                                                    }}</button>
                                                <button class="button-red"
                                                    *ngIf="releaseElement.ApprovalStatus==2 && releaseElement.ActivationStatus==2"
                                                    (click)="rejectRollout(releaseElement)">{{
                                                    languageService.languageJSON.Global_Reject }}</button>
                                                <button
                                                    *ngIf="releaseElement.ApprovalStatus==2 && releaseElement.ActivationStatus==2"
                                                    (click)="approveRollout(releaseElement)">{{
                                                    languageService.languageJSON.Global_Approve }}</button>
                                                <button class="button-red"
                                                    *ngIf="releaseElement.ApprovalStatus==3 && releaseElement.ActivationStatus==2"
                                                    (click)="deactivateRollout(releaseElement)">{{
                                                    languageService.languageJSON.ReleaseOverview_Deactivate }}</button>
                                            </div>
                                            <div class="flex-col modify-icons medium-col"
                                                *ngIf="!releaseElement.ModifyRole"></div>
                                            <div class="flex-col modify-icons">
                                                <div class="icon-outer">
                                                    <div class="icon-element-outer"
                                                        (click)="viewRelease(releaseElement.Id)">
                                                        <img src="assets/icons/eye-look.svg" />
                                                    </div>
                                                    <div class="icon-element-outer"
                                                        (click)="viewMonitorRelease(releaseElement.Id)">
                                                        <img src="assets/icons/column-chart-line-icon.svg" />
                                                    </div>
                                                    <div class="icon-element-outer" *ngIf="releaseElement.ModifyRole"
                                                        [ngClass]="{'inactive-with-popup': releaseElement.ReleaseDeleteInactive }"
                                                        [matTooltip]="releaseElement.ReleaseDeleteInactive ? languageService.languageJSON.ReleaseOverview_DeleteInactive: ''"
                                                        matTooltipClass="configtool-tooltip"
                                                        (click)="deleteRelease(releaseElement)">
                                                        <img class="delete-icon" src="assets/icons/delete.svg" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flex-row" *ngIf="componentVariant.releases.length==0">
                                            <div class="flex-col">
                                                {{ languageService.languageJSON.Global_NoItems }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <app-loading-animation *ngIf="loading"></app-loading-animation>
        </div>
    </div>
</form>